import * as React from 'react';
import { Text, View ,StyleSheet, TextInput ,TouchableOpacity ,useState} from 'react-native';
import { FontAwesome } from '@expo/vector-icons'; 
import Swal from 'sweetalert2'

export default function dadospessoaiscadastro({route,navigation}) {
    const [banco,setBanco] = React.useState('');
    const [agencia,setAgencia] =React.useState('');
    const [conta,setConta] = React.useState('');
    const [cpf, setCpf]= React.useState('');
    const [nome,setNome]= React.useState('');
    const [tipoconta,setTipo]= React.useState('');
    const [operacao,setOperacao]= React.useState('');
    const cod=route.params.id;
    const userid=route.params.userid;
    //const register bank
    //console.log(userid);

  const ativation=(userid,cod,banco,agencia,conta,tipoconta,operacao,cpf,nome)=>{

    var validatinoApi ='https://emprestimoimperion.com/composer/controller/api/cadastrodadosbancarios.php';
    var headers={
     'Accept':'application/json',
     'Content-Type':'application.json',
     'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
     'Access-Control-Allow-Origin':'*',
     'crossDomain': 'true',
     'Host': 'https://emprestimoimperion.com/composer/controller/api/cadastrodadosbancarios.php',
     'Origin': 'https://emprestimoimperion.com',
     'credentials': 'same-origin',
     'Access-Control-Allow-Credentials': 'true'
     
      };
     /*'crossDomain': 'true',*/
     var Data={
      userid:userid,
      cod:cod,
      banco:banco,
      agencia:agencia,
      conta:conta,
      tipoconta:tipoconta,
      operacao:operacao,
      cpf:cpf,
      nome:nome,
      };
  
      fetch(validatinoApi,
      {
      method:'POST',
      headers:headers,
      body:JSON.stringify(Data)
      }).then((response)=>response.json())
      .then((response)=>{
      if(response.statusCode==200){
      navigation.navigate('logado')
      }else{
        Swal.fire({
          position: 'top',
          icon: 'error',
          title: 'Algo deu errado',
          showConfirmButton: false,
          timer: 2000
        })
      } 
      }).catch((error)=>{
      alert(error);
      });
      
    }
  
  

  


  return (
<View style={{ flex: 1, alignItems: 'center' ,backgroundColor:'#01150E' }}>

<View style={{margin:10}}><FontAwesome name="bank" size={80} color="white" margin={40}/></View>

        <TextInput
        onChangeText={(banco) => setBanco(banco)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Nome do banco"
        />

        <TextInput
        onChangeText={(agencia) => setAgencia(agencia)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Numero Agência"
        />
 
        <TextInput
        onChangeText={(conta) => setConta(conta)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Conta com DIGITO"
        />

<TextInput
        onChangeText={(tipoconta) => setTipo(tipoconta)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Conta corrente ou poupança ?"
        />

       <TextInput
        onChangeText={(operacao) => setOperacao(operacao)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Numero Operacao se tiver"
        />

       <TextInput
        onChangeText={(cpf) => setCpf(cpf)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="CPF titular da conta"
        />

        <TextInput
        onChangeText={(nome) => setNome(nome)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Nome do titular da conta"
        />

      <TouchableOpacity onPress = {() => {/* do this */
      if(banco.length>0){
        ativation(userid,cod,banco,agencia,conta,tipoconta,operacao,cpf,nome);
        
      }}}>
    <View style = {{backgroundColor: 'white', alignItems: 'center', 
                    justifyContent: 'center' ,borderRadius: 10,width:110 }}
           >
        <Text style = {{ color: '#01150E', padding:10}}>Gravar</Text>
          </View>
</TouchableOpacity>

<View style={{marginTop:20}}>

</View>

</View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 16,
    marginVertical: 32,
  },
  section: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  paragraph: {
    fontSize: 15,
    color:'white'
  },
  checkbox: {
    margin: 8,
  },
});